class MirrorConsoleConfiguration {
    private get config() {
        return (window as any).APP_CONFIG ?? {};
    }

    get Env(){
        return this.config.REACT_APP_ENV;
    }

    get DefaultApi() {
        return this.config.REACT_APP_DEFAULT_API;
    }

    get MirrorApi() {
        return this.config.REACT_APP_MIRROR_API;
    }

    get ConsoleApi() {
        return this.config.REACT_APP_CONSOLE_API;
    }

    get ThwallUrl() {
        return this.config.REACT_APP_THWALL_URL;
    }

    get SocketServer() {
        return this.config.REACT_APP_SOCKET_SERVER;
    }

    get IsProduction() {
        return this.config.REACT_APP_ENV === 'production';
    }

    get IsStaging() {
        return this.config.REACT_APP_ENV === 'staging';
    }

    get IsQA() {
        return this.config.REACT_APP_ENV === 'qa';
    }

    get IsLocal() {
        return this.config.REACT_APP_ENV === 'develop';
    }

}

const config = new MirrorConsoleConfiguration();
export default config;